'use strict';exports.__esModule = true;exports.reset = exports.sendRealtorContactUsForm = exports.closeRealtorContactUsForm = exports.openRealtorContactUsForm = exports.loadRealtorProps = exports.loadRealtor = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var getRoute = function getRoute(id) {return 'users/agents/' + id;};
var REALTOR_CONTACT_US_URL = 'mailing/contact_realtor';

var loadRealtor = (0, _reduxAct.createAction)('/LOAD_REALTOR');
var loadRealtorSuccess = (0, _reduxAct.createAction)('/LOAD_REALTOR_SUCCESS');
var loadRealtorFail = (0, _reduxAct.createAction)('/LOAD_REALTOR_FAIL');
var loadRealtorProps = (0, _reduxAct.createAction)('/LOAD_REALTOR_PROPS');
var loadRealtorPropsSuccess = (0, _reduxAct.createAction)('/LOAD_REALTOR_PROPS_SUCCESS');
var loadRealtorPropsFail = (0, _reduxAct.createAction)('/LOAD_REALTOR_PROPS_FAIL');
var openRealtorContactUsForm = (0, _reduxAct.createAction)('/OPEN_REALTOR_CONTACT_US_FORM');
var closeRealtorContactUsForm = (0, _reduxAct.createAction)('/CLOSE_REALTOR_CONTACT_US_FORM');
var sendRealtorContactUsForm = (0, _reduxAct.createAction)('/SEND_REALTOR_CONTACT_US');
var sendRealtorContactUsFormSuccess = (0, _reduxAct.createAction)('/SEND_REALTOR_CONTACT_US_SUCCESS');
var sendRealtorContactUsFormFail = (0, _reduxAct.createAction)('/SEND_REALTOR_CONTACT_US_FAIL');
var reset = (0, _reduxAct.createAction)('/RESET_REALTOR');

var initialState = {
  data: null,
  properties: null,
  loaded: false,
  loading: false,
  propertiesLoaded: false,
  propertiesLoading: false,
  error: null,
  propertiesError: null,
  mobileContactUsIsOpen: false,
  formSubmitting: false,
  formSubmitted: false };


var setPropertyOption = function setPropertyOption(properties, optionType) {return properties.map(function (property) {
    property.option_type = optionType;
    return property;
  });};

var fetchLoad = function fetchLoad(id) {return _axios2.default.get(getRoute(id)).
  then(loadRealtorSuccess, loadRealtorFail);};

var fetchRealtorProps = function fetchRealtorProps(id) {return Promise.all([
  _axios2.default.get('properties/search?user_id=' + id + '&option=buy'),
  _axios2.default.get('properties/search?user_id=' + id + '&option=rent')]).

  then(function (response) {var
    dataForSell = response[0].data,dataForRent = response[1].data;
    return [].concat(setPropertyOption(dataForSell.data, 'buy'), setPropertyOption(dataForRent.data, 'rent'));
  }).
  then(loadRealtorPropsSuccess).
  catch(loadRealtorPropsFail);};

var submitRealtorContactUsForm = function submitRealtorContactUsForm(data) {return _axios2.default.post(REALTOR_CONTACT_US_URL, data).
  then(sendRealtorContactUsFormSuccess).
  catch(sendRealtorContactUsFormFail);};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchLoad, action));};

var handleLoadSuccess = function handleLoadSuccess(state, _ref) {var data = _ref.data;return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: data });};


var handleLoadFail = function handleLoadFail(state, err) {
  var error = err.response.data;


  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var handleLoadRealtorProps = function handleLoadRealtorProps(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    propertiesLoading: true }),
  promise(fetchRealtorProps, action));};

var handleLoadRealtorPropsSuccess = function handleLoadRealtorPropsSuccess(state, action) {return Object.assign({},
  state, {
    propertiesLoaded: true,
    propertiesLoading: false,
    propertiesError: null,
    properties: action });};


var handleLoadRealtorPropsFail = function handleLoadRealtorPropsFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Failed to get realtor properties');
  return Object.assign({},
  state, {
    propertiesLoaded: false,
    propertiesLoading: false,
    propertiesError: error });

};

var handleOpenContactUsForm = function handleOpenContactUsForm(state) {return Object.assign({},
  state, {
    mobileContactUsIsOpen: true });};


var handleCloseRealtorContactUsForm = function handleCloseRealtorContactUsForm(state) {return Object.assign({},
  state, {
    mobileContactUsIsOpen: false });};


var handleSendRealtorContactUsForm = function handleSendRealtorContactUsForm(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    formSubmitting: true }),
  promise(submitRealtorContactUsForm, action));};

var handleSendRealtorContactUsFormSuccess = function handleSendRealtorContactUsFormSuccess(state) {return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: null,
    mobileContactUsIsOpen: false });};


var handleSendRealtorContactUsFormFail = function handleSendRealtorContactUsFormFail(state, _ref2) {var response = _ref2.response;return Object.assign({},
  state, {
    formSubmitting: false,
    formSubmitted: true,
    formError: response.data });};


var handleReset = function handleReset() {return Object.assign({}, initialState);};

var realtor = (0, _reduxAct.createReducer)(function (on) {
  on(loadRealtor, handleLoad);
  on(loadRealtorSuccess, handleLoadSuccess);
  on(loadRealtorFail, handleLoadFail);
  on(loadRealtorProps, handleLoadRealtorProps);
  on(loadRealtorPropsSuccess, handleLoadRealtorPropsSuccess);
  on(loadRealtorPropsFail, handleLoadRealtorPropsFail);
  on(openRealtorContactUsForm, handleOpenContactUsForm);
  on(closeRealtorContactUsForm, handleCloseRealtorContactUsForm);
  on(sendRealtorContactUsForm, handleSendRealtorContactUsForm);
  on(sendRealtorContactUsFormSuccess, handleSendRealtorContactUsFormSuccess);
  on(sendRealtorContactUsFormFail, handleSendRealtorContactUsFormFail);
  on(reset, handleReset);
}, initialState);exports.


loadRealtor = loadRealtor;exports.
loadRealtorProps = loadRealtorProps;exports.
openRealtorContactUsForm = openRealtorContactUsForm;exports.
closeRealtorContactUsForm = closeRealtorContactUsForm;exports.
sendRealtorContactUsForm = sendRealtorContactUsForm;exports.
reset = reset;exports.default =


realtor;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/realtor.js
// module id = 1294
// module chunks = 0